export interface DeviceTypeRecord {
    deviceType: string,
    isDeleteConfigSupported: boolean,
    config: string,
    supportsTudr: boolean,
    commandFileTypeIds: string[],
    responseFileTypeIds: string[],
    limit: string
}
export interface ConfigSupported {
    config: string,
    supportsTudr: boolean,
    commandFileTypeIds: string[],
    responseFileTypeIds: string[],
    limit: string,
    supportsDelete: boolean
}
export interface ConfigCapabilities {
    onboardApplicationMessageVersion: number,
    deviceType: string,
    isDeleteConfigSupported?: boolean,
    configsSupported: Array<ConfigSupported>
}

export interface DeviceTypeState {
    activeDeviceTypeRecord: DeviceTypeRecord,
    deviceTypePool: ConfigCapabilities[],
    deviceTypes: string[],
    commandFileTypeIds: string[],
    responseFileTypeIds: string[],
    configNames: string[]
}

export enum DeviceTypeActionNames {
    SET_DEFAULTS = 'SET_DEFAULTS',
    SET_DEVICE_TYPE_CONFIG = 'SET_DEVICE_TYPE_CONFIG'
  }

  interface SetDeviceIds {
    type: typeof DeviceTypeActionNames.SET_DEFAULTS;
    payload: ConfigCapabilities[];
  }
  interface SetDeviceTypeConfig {
    type: typeof DeviceTypeActionNames.SET_DEVICE_TYPE_CONFIG
    payload: DeviceTypeRecord
  }


  export type DeviceTypeActionTypes =
    | SetDeviceIds
    | SetDeviceTypeConfig